import $ from 'jquery';
import isElement from '../../scripts/util/isElement';

const selectors = {
	gallery: '.js--price-gallery',
	tab: '.js--tariff-tab',
	tariffs: '.js--tariffs-type'
};

const changeTariffs = () => {
	const gallery = $(selectors.gallery);
	const tab = $(selectors.tab);
	const tariffs = $(selectors.tariffs);

	tab.on('click', function () {
		tab.each(function () {
			$(this).removeClass('is--active');
		});
		$(this).addClass('is--active');

		const type = $(this).attr('data-type');
		tariffs.attr('data-type', type);
		gallery.attr('data-type', type);
	});
};

const render = () => {
	if (isElement(selectors.tab)) {
		changeTariffs();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/price-gallery/price-gallery.js